import styled from "styled-components";

export const Wrapper = styled.div`
  margin-top: 24px;
  width: 100%;
  font-family: "Inter", sans-serif;

  .schedule-btn {
    position: fixed;
    bottom: 8px;
    right: 16px;
    left: 16px;
    width: auto;
    z-index: 1000;

    &:disabled,
    &[aria-disabled="true"] {
      background-color: ${({ theme }) => theme.palette.greyscale.grey300};
      border-color: ${({ theme }) => theme.palette.greyscale.grey300};
      color: #fff;
      cursor: not-allowed;
      pointer-events: none;
      opacity: 1;
    }

    &:disabled:hover,
    &[aria-disabled="true"]:hover {
      background-color: ${({ theme }) => theme.palette.greyscale.grey300};
    }
  }

  & > button:first-of-type {
    margin-top: 24px;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    margin-top: 40px;
    & > button:first-of-type {
      margin-top: 40px;
    }
  }
  @media (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    margin-top: 0px;
    padding: 24px;
    border: 1px solid hsl(245 60% 96%);
    border-radius: 8px;
    max-width: 480px;
    position: sticky;
    top: 0;

    .schedule-btn {
      position: static;
      bottom: unset;
      width: 100%;
    }

    & > button:first-of-type {
      margin-top: 24px;
    }
  }
`;

export const Title = styled.h6`
  color: ${({ theme }) => theme.palette.greyscale.grey800};
  font-weight: 700;
  font-size: ${16 / 16}rem;
  display: none;

  @media (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    display: unset;
  }
`;

export const ValuesWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px 8px;
  margin-top: 8px;
  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    grid-template-columns: repeat(4, 1fr);
  }
  @media (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    row-gap: 16px;
    margin-top: 24px;
    grid-template-columns: repeat(2, 1fr);
  }
`;

export const ValueWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  border: 1px solid hsl(245 60% 96%);
  border-radius: 8px;
  padding: 16px;
  & svg {
    min-width: 24px;
    min-height: 24px;
    color: ${({ theme }) => theme.palette.secondary.orange500};
  }
  @media (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    padding: 0;
    border: none;
  }
`;

export const TitlePriceWrapper = styled.div``;

export const CategoryTitle = styled.p`
  font-weight: 300;
  font-size: ${14 / 16}rem;
  color: ${(props) => props.theme.palette.greyscale.grey400};
`;

export const Price = styled.p`
  font-weight: 600;
  font-size: ${16 / 16}rem;
  color: ${(props) => props.theme.palette.black.default};
`;

export const Warnings = styled.div`
  background-color: rgba(255, 254, 241, 1);
  color: rgba(224, 184, 40, 1);
  font-size: ${12 / 16}rem;
  font-weight: 400;
  margin-top: 24px;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px;
  & svg {
    min-width: 14px;
    min-height: 14px;
    color: rgba(224, 184, 40, 1);
  }
`;

export const TotalTitle = styled.p`
  font-size: ${14 / 16}rem;
  font-weight: 400;
  text-align: right;
  color: ${({ theme }) => theme.palette.black.default};
  margin-top: 16px;

  @media (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    display: block;
  }
`;

export const TotalPrice = styled.p`
  font-size: ${24 / 16}rem;
  font-weight: 700;
  text-align: right;
  color: ${(props) => props.theme.palette.primary.blue500};

  @media (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    display: block;
  }
`;

export const ButtonsContainer = styled.div`
  display: flex;
  gap: 16px;
  margin-top: 8px;

  & a {
    flex: 1;
  }
`;
